// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Icon__Jsx3 = require("../../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var ReactAriaComponents = require("react-aria-components");

function QuestionPopover(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var holderClass = TailwindMerge.twMerge([
        "relative flex items-center normal-case",
        className
      ]);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs(ReactAriaComponents.MenuTrigger, {
                    children: [
                      JsxRuntime.jsx(ReactAriaComponents.Button, {
                            children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                  icon: "Question",
                                  size: 16
                                }),
                            className: (function (param) {
                                return "group inline-flex items-center justify-center w-4 h-4 p-0 border-0 bg-transparent cursor-pointer focus:outline-none transition duration-150 text-zinc-400 aria-expanded:text-zinc-600";
                              }),
                            type: "button"
                          }),
                      JsxRuntime.jsx(ReactAriaComponents.Popover, {
                            children: JsxRuntime.jsx("div", {
                                  children: props.children,
                                  className: "relative"
                                }),
                            className: "mb-1 w-52 sm:w-72 z-10 rounded-md px-3.5 py-2 text-base leading-tight text-white bg-zinc-700/95 before:content-[''] before:absolute before:left-1/2 before:bottom-0 before:-translate-x-1/2 before:translate-y-[9px] before:w-0 before:h-0 before:border-solid before:border-t-[9px] before:border-x-[7px] before:border-x-transparent before:border-t-zinc-700/95",
                            placement: "top"
                          })
                    ]
                  }),
              className: holderClass
            });
}

var make = QuestionPopover;

exports.make = make;
/* Icon__Jsx3 Not a pure module */
